import MarginOptions from './MarginOptions'
import RightBarGroup from './RightBarGroup'
import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import ImageOptions from './ImageOptions'
import {
  ChangeEvent,
  DynamicContentType,
  FileEntryBM,
  GalleryData,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  setData: (e: ChangeEvent<string | (FileEntryBM | undefined)[]>) => void
  content: DynamicContentType<GalleryData>
}

const GalleryEditor = ({ setData, content }: Props) => {
  const { tr } = useTr()

  const addImage = () => {
    const newImage = undefined
    const event = {
      target: {
        name: 'images',
        value: [...content.data.images, newImage],
      },
    }
    setData(event)
  }

  const removeImage = (index: number) => {
    const newImages = content.data.images.filter((_, i) => i !== index)
    const event = {
      target: {
        name: 'images',
        value: newImages,
      },
    }
    setData(event)
  }

  const updateImage = (index: number, newImage: FileEntryBM | undefined) => {
    const newImages = content.data.images.map((image, i) => {
      if (i === index) {
        return newImage
      }
      return image
    })
    const event = {
      target: {
        name: 'images',
        value: newImages,
      },
    }
    setData(event)
  }

  const moveImage = (from: number, to: number) => {
    if (to < 0 || to >= content.data.images.length) return

    const images = [...content.data.images]
    const [removed] = images.splice(from, 1)
    images.splice(to, 0, removed)
    const event = {
      target: {
        name: 'images',
        value: images,
      },
    }
    setData(event)
  }

  return (
    <>
      {content.data.images.map((image, index) => (
        <div key={index}>
          <Input
            type='image'
            value={image}
            deleteMedia={() => removeImage(index)}
            moveMedia={(diff) => moveImage(index, index + diff)}
            setter={(f) => updateImage(index, f)}
          />
        </div>
      ))}
      <Button className='mb-4' onClick={addImage}>
        {tr(TrKey.galleryEditorAddImage)}
      </Button>
      <RightBarGroup title={tr(TrKey.galleryEditorImageSettingsTitle)} topLine>
        <ImageOptions content={content} setData={setData} />
      </RightBarGroup>
      <MarginOptions setData={setData} content={content} />
    </>
  )
}

export default GalleryEditor
